export default (() => {
    const tables = Array.from(document.querySelectorAll('.ProductsTable'));

    tables.forEach((table) => {
        let index = 0;
        let displayCount = 4;
        const cardCount = Number(table.dataset.productCount);
        const nextBtn = table.querySelector('.ProductsTable__button.next');
        const prevBtn = table.querySelector('.ProductsTable__button.prev');
        const wrapper = table.querySelector('.ProductsTable__table-wrap');

        const applyCardClasses = () => {
            for (let i = 0; i < cardCount; i++) {
                const hidePast = i < index ? 'hide-past' : '';
                const hideUpcoming = i > index + displayCount ? 'hide-upcoming' : '';
                const next = i === index + displayCount ? 'next' : '';
                const cards = Array.from(
                    table.querySelectorAll(
                        `.ProductsTable .ProductsTable__cell:nth-child(${i + 2})`
                    )
                );
                cards.forEach(
                    (card) =>
                        (card.classList = `ProductsTable__cell ${hidePast} ${hideUpcoming} ${next}`)
                );
            }
        };

        const applyWrapperClasses = () => {
            wrapper.classList.remove('first-card');
            wrapper.classList.remove('last-card');

            if (index === 0) {
                wrapper.classList.add('first-card');
            }
            if (index >= cardCount - displayCount) {
                wrapper.classList.add('last-card');
            }
        };

        const handleClasses = () => {
            applyCardClasses();
            applyWrapperClasses();
        };

        const handleResize = () => {
            const wide = window.matchMedia(`(min-width: 1280px)`).matches;
            displayCount = wide ? 4 : 3;
        };

        const reset = () => {
            index = 0;
            handleResize();
            handleClasses();
        };

        const forward = () => {
            if (index < cardCount - displayCount) {
                index = index + 1;
                handleClasses();
            }
        };

        const back = () => {
            if (index > 0) {
                index = index - 1;
                handleClasses();
            }
        };

        nextBtn.addEventListener('click', () => forward());
        prevBtn.addEventListener('click', () => back());
        window.addEventListener('resize', () => reset());
        reset();
    });
})();
